import { render, staticRenderFns } from "./AccountingEmployeesList.vue?vue&type=template&id=13845bc8&"
import script from "./AccountingEmployeesList.vue?vue&type=script&lang=ts&"
export * from "./AccountingEmployeesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports